import { createSlice } from '@reduxjs/toolkit';

import { fetchAuthCode, fetchLoggedInUser, logout, refreshAuthCode } from './actions';

import type { AuthCodeError } from './types';
import type { UserProfile } from '../apiTypes';

interface AuthState {
  isFetching: boolean;
  error: AuthCodeError | undefined;
  item: { token?: string };
  loggedInUser?: UserProfile;
}

const initialState: AuthState = {
  isFetching: false,
  error: { status: 0, message: '' },
  item: {},
  loggedInUser: undefined,
};

const authSlice = createSlice({
  name: 'authCode',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Logout
      .addCase(logout.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(logout.fulfilled, (state) => {
        state.isFetching = false;
        state.item = {};
        state.loggedInUser = undefined;
      })
      .addCase(logout.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
      })
      // Refresh Auth Code
      .addCase(refreshAuthCode.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(refreshAuthCode.fulfilled, (state, action) => {
        state.isFetching = false;
        state.item.token = action.payload.token;
      })
      .addCase(refreshAuthCode.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
      })
      // Fetch Auth Code
      .addCase(fetchAuthCode.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(fetchAuthCode.fulfilled, (state, action) => {
        state.isFetching = false;
        state.item.token = action.payload.token;
      })
      .addCase(fetchAuthCode.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
      })
      // Fetch LoggedInUser data
      .addCase(fetchLoggedInUser.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(fetchLoggedInUser.fulfilled, (state, action) => {
        state.isFetching = false;
        state.loggedInUser = action.payload;
      })
      .addCase(fetchLoggedInUser.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
      });
  },
});

export const authCodeReducer = authSlice.reducer;
export type AuthCodeState = ReturnType<typeof authSlice.reducer>;
